<script setup>
defineProps(['isDark'])
</script>
<template>
	<div :class="isDark ? 'bg-bgSecondary' : 'bg-bgMain'">
		<section class="container"></section>
	</div>
</template>
